import getTaskGraphLogFromCache from './getTaskGraphLogFromCache';

export default getTaskGraphLogFromCache;
